import pretty from 'pretty';
import * as React from 'react';
const OriginalHTML = ({ html, prettify }) => {
    const divElement = React.useRef(null);
    React.useLayoutEffect(() => {
        const div = divElement.current;
        if (html !== undefined && div != null) {
            const pre = document.createElement('pre');
            const text = prettify ? pretty(html, { ocd: false }) : html;
            let textNodeString = '';
            let numberOfCharacters = 0;
            let inTag = true;
            let firstNodeOfLine = null;
            text.split('').forEach((character) => {
                if (character === '<') {
                    inTag = true;
                }
                else if (character === '>') {
                    inTag = false;
                }
                else if (!inTag && character !== '\n') {
                    numberOfCharacters += 1;
                }
                if (character === ' ') {
                    const textNode = document.createTextNode(textNodeString);
                    if (firstNodeOfLine === null && textNodeString.length > 0 && textNodeString !== '\n')
                        firstNodeOfLine = textNode;
                    pre.appendChild(textNode);
                    textNodeString = '';
                    const span = document.createElement('span');
                    span.className = 'co-special-char';
                    span.innerText = '·';
                    pre.appendChild(span);
                    firstNodeOfLine ??= span;
                }
                else if (character === '\r') {
                    const textNode = document.createTextNode(textNodeString);
                    pre.appendChild(textNode);
                    textNodeString = '';
                    const span = document.createElement('span');
                    span.className = 'co-special-char';
                    span.innerText = '␍';
                    pre.appendChild(span);
                    textNodeString += character;
                    firstNodeOfLine ??= span;
                }
                else if (character === '\t') {
                    const textNode = document.createTextNode(textNodeString);
                    pre.appendChild(textNode);
                    textNodeString = '';
                    const span = document.createElement('span');
                    span.className = 'co-special-char';
                    span.innerText = '⇥';
                    pre.appendChild(span);
                    textNodeString += character;
                    firstNodeOfLine ??= span;
                }
                else if (character === '\n') {
                    const textNode = document.createTextNode(textNodeString);
                    pre.appendChild(textNode);
                    textNodeString = '';
                    const span = document.createElement('span');
                    span.className = 'co-special-char';
                    span.innerText = '↵';
                    pre.appendChild(span);
                    textNodeString += character;
                    const numberText = document.createElement('span');
                    numberText.innerText = `[${numberOfCharacters.toString()}]`;
                    numberText.className = 'co-count';
                    inTag = true;
                    if (firstNodeOfLine === null) {
                        pre.appendChild(numberText);
                    }
                    else {
                        firstNodeOfLine.before(numberText);
                    }
                    numberOfCharacters = 0;
                    firstNodeOfLine = null;
                }
                else {
                    textNodeString += character;
                }
            });
            if (textNodeString !== '') {
                const textNode = document.createTextNode(textNodeString);
                pre.appendChild(textNode);
            }
            while (divElement.current?.children.item(0) !== null) {
                const t = divElement.current?.children.item(0);
                if (t !== null && t !== undefined) {
                    t.remove();
                }
            }
            divElement.current.appendChild(pre);
        }
    }, [html, prettify]);
    return (React.createElement("div", { ref: divElement }));
};
export default OriginalHTML;
